
import React from 'react';
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Clock, Edit, Trash2 } from "lucide-react";

interface Period {
  startTime: string;
  endTime: string;
}

interface PeriodsListProps {
  periods: Period[];
  onEditClick: () => void;
  onDeletePeriod: (period: Period) => void;
}

const PeriodsList: React.FC<PeriodsListProps> = ({
  periods,
  onEditClick,
  onDeletePeriod
}) => {
  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-medium flex items-center gap-2">
          <Clock className="h-4 w-4" />
          Períodos Configurados
        </h3>
        <Button variant="outline" size="sm" onClick={onEditClick}>
          <Edit className="h-4 w-4 mr-2" />
          Editar
        </Button>
      </div>
      
      <div className="space-y-3">
        {periods.map((period, index) => {
          console.log(`🎯 [PeriodsList] Renderizando período ${index + 1}:`, period);
          return (
            <div 
              key={`${period.startTime}-${period.endTime}-${index}`}
              className="flex items-center justify-between p-4 border rounded-lg bg-blue-50 hover:bg-blue-100 transition-colors"
            >
              <div className="flex items-center gap-3">
                <Clock className="h-5 w-5 text-blue-600" />
                <span className="font-medium text-lg">
                  {period.startTime.substring(0, 5)} - {period.endTime.substring(0, 5)}
                </span>
                <Badge variant="secondary" className="text-xs">
                  {(() => {
                    const start = period.startTime.substring(0, 5);
                    const end = period.endTime.substring(0, 5);
                    const [startHour, startMin] = start.split(':').map(Number);
                    const [endHour, endMin] = end.split(':').map(Number);
                    const startMinutes = startHour * 60 + startMin;
                    const endMinutes = endHour * 60 + endMin;
                    const totalMinutes = endMinutes - startMinutes;
                    const slots = totalMinutes / 30;
                    return `${slots} slots de 30 minutos`;
                  })()}
                </Badge>
              </div>
              
              <Button
                size="lg"
                variant="destructive"
                onClick={() => onDeletePeriod(period)}
                className="ml-4 h-12 w-12 p-0 bg-red-500 hover:bg-red-600 border-2 border-red-700 flex-shrink-0"
                title={`🗑️ Remover período ${period.startTime.substring(0, 5)} - ${period.endTime.substring(0, 5)}`}
                style={{ 
                  backgroundColor: '#ef4444',
                  borderColor: '#b91c1c',
                  minWidth: '48px',
                  minHeight: '48px'
                }}
              >
                <Trash2 className="h-6 w-6 text-white" />
              </Button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PeriodsList;
